import { AlertTriangle } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

// Candado de salida: bloquea el cierre de sesión con turno con movimientos — presentacional.
export const LogoutBloqueadoDialog = ({ logoutWarnOpen, setLogoutWarnOpen }) => (
  <Dialog open={logoutWarnOpen} onOpenChange={setLogoutWarnOpen}>
    <DialogContent className="rounded-none border-2 border-[#EF4444] bg-[#0A0A0A] text-white sm:max-w-lg max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="logout-bloqueado-modal">
      <div className="flex flex-col items-center text-center gap-4 py-6">
        <div className="h-20 w-20 rounded-full bg-[#EF4444]/15 border-2 border-[#EF4444] flex items-center justify-center animate-pulse">
          <AlertTriangle className="h-10 w-10 text-[#EF4444]" />
        </div>
        <h2 className="font-display text-2xl font-black text-white uppercase tracking-tight">No puedes cerrar sesión</h2>
        <p className="text-white/70 text-base leading-relaxed px-2">No puedes cerrar sesión con un turno abierto. Por favor, realiza el corte de caja primero.</p>
        <button onClick={() => setLogoutWarnOpen(false)} data-testid="logout-bloqueado-entendido"
          className="btn-hard mt-2 h-12 px-10 bg-[#EF4444] text-white border border-[#EF4444] font-bold uppercase tracking-wider">Entendido</button>
      </div>
    </DialogContent>
  </Dialog>
);

export default LogoutBloqueadoDialog;
